import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { HistoricEnrollmentStatus } from '@/components/organisms';
import { HistoryEnrollmentList } from './templates/HistoryEnrollmentList/HistoryEnrollmentList';
import * as Styled from './History.style';
// --- MOCKS ESPECÍFICOS DO HISTORY ENROLLMENT LIST ---
const mockEnrollmentCards = [
    {
        imageSrc: 'https://ava.sebrae.com.br/App/Api/Training/Training/GetTrailImageBase64?idTraining=5318',
        type: 'Curso | ',
        title: 'Imersão Empreendedora Sebrae',
        courseWorkload: '3h',
        pageBrowsingTime: '1h 15min',
        lastAccessDate: '13/08/2025',
        status: HistoricEnrollmentStatus.COMPLETED,
        enrollmentDate: '30/07/2025',
        deadlineDate: '14/08/2025',
        progress: 100,
        buttonText: 'Certificado',
        isInEditor: false,
        cqPath: '',
    },
    {
        imageSrc: 'https://ava.sebrae.com.br/App/Api/Training/Training/GetActivityImageBase64?idTraining=3487&typeTraining=OnlineCourse',
        type: 'Curso | ',
        title: 'Comece a empreender na comunidade',
        courseWorkload: '3h',
        pageBrowsingTime: '1h 15min',
        lastAccessDate: '13/08/2025',
        status: HistoricEnrollmentStatus.COMPLETED,
        enrollmentDate: '30/07/2025',
        deadlineDate: '14/08/2025',
        progress: 100,
        buttonText: 'Certificado',
        isInEditor: false,
        cqPath: '',
    },
    {
        imageSrc: 'https://ava.sebrae.com.br/App/Api/Training/Training/GetActivityImageBase64?idTraining=2878&typeTraining=OnlineCourse',
        type: 'Curso | ',
        title: 'Marketing de Conteúdo',
        courseWorkload: '3h',
        pageBrowsingTime: '1h 15min',
        lastAccessDate: '13/08/2025',
        status: HistoricEnrollmentStatus.COMPLETED,
        enrollmentDate: '30/07/2025',
        deadlineDate: '14/08/2025',
        progress: 100,
        buttonText: 'Certificado',
        isInEditor: false,
        cqPath: '',
    },
    {
        imageSrc: 'https://ava.sebrae.com.br/App/Api/Training/Training/GetActivityImageBase64?idTraining=3538&typeTraining=OnlineCourse',
        type: 'Curso | ',
        title: 'Design Thinking',
        courseWorkload: '3h',
        pageBrowsingTime: '1h 15min',
        lastAccessDate: '13/08/2025',
        status: HistoricEnrollmentStatus.COMPLETED,
        enrollmentDate: '30/07/2025',
        deadlineDate: '14/08/2025',
        progress: 100,
        buttonText: 'Certificado',
        isInEditor: false,
        cqPath: '',
    },
];
const mockFilterSections = [
    {
        id: 'status',
        label: 'Situação de Progresso',
        options: [
            { id: 'not_started', label: 'Não iniciado', value: 'not_started' },
            { id: 'in_progress', label: 'Em andamento', value: 'in_progress', checked: true },
            { id: 'completed', label: 'Concluído', value: 'completed', checked: true },
            { id: 'not_completed', label: 'Não concluído', value: 'expired' },
            { id: 'approved', label: 'Aprovado', value: 'approved' },
            { id: 'not_approved', label: 'Reprovado', value: 'not_approved' },
            { id: 'abandon', label: 'Abandono', value: 'abandon' },
        ],
    },
    {
        id: 'type',
        label: 'Situação de matrícula',
        options: [
            { id: 'canceled', label: 'Cancelado', value: 'canceled' },
            { id: 'dropout', label: 'Desistente', value: 'dropout' },
            { id: 'enrolled', label: 'Matriculado', value: 'enrolled' },
        ],
    },
];
// --- COMPONENTE DE PÁGINA ---
export const HistoryPage = () => {
    const [filters, setFilters] = useState(mockFilterSections);
    const handleFilterChange = (sectionId, value, checked) => {
        console.log('Filtro alterado:', { sectionId, value, checked });
        setFilters(prevFilters => prevFilters.map(section => {
            if (section.id === sectionId) {
                return Object.assign(Object.assign({}, section), { options: section.options.map(opt => opt.value === value ? Object.assign(Object.assign({}, opt), { checked }) : opt) });
            }
            return section;
        }));
    };
    const handleRemoveFilter = (sectionId, value) => {
        console.log('Removendo filtro:', { sectionId, value });
        handleFilterChange(sectionId, value, false);
    };
    const handleClearFilters = () => {
        console.log('Limpando todos os filtros');
        setFilters(prevFilters => prevFilters.map(section => (Object.assign(Object.assign({}, section), { options: section.options.map(opt => (Object.assign(Object.assign({}, opt), { checked: false }))) }))));
    };
    return (_jsx(Styled.Fragment, { children: _jsx(HistoryEnrollmentList, { filterSections: filters, historicEnrollmentCards: mockEnrollmentCards, totalItems: mockEnrollmentCards.length, itemsPerPage: 6, onFilterChange: handleFilterChange, onRemoveFilter: handleRemoveFilter, onClearFilters: handleClearFilters, inverse: false }) }));
};
//# sourceMappingURL=History.js.map